(() => {
  const money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const clean = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const html = value => String(value || '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const family = value => {
    const v = clean(value);
    if (v.includes('azul') || v.includes('nautico')) return 'Azul';
    if (v.includes('verde') || v.includes('sage') || v.includes('menta')) return 'Verde';
    if (v.includes('rosa') || v.includes('mauve') || v.includes('lilas')) return 'Rosa e lilás';
    if (v.includes('marrom') || v.includes('mocha') || v.includes('caramelo') || v.includes('areia')) return 'Terrosos';
    if (v.includes('preto') || v.includes('cinza')) return 'Preto e cinza';
    if (v.includes('branco') || v.includes('off-white')) return 'Branco';
    if (v.includes('vermelho') || v.includes('bordo') || v.includes('figo') || v.includes('roxo') || v.includes('uva')) return 'Vermelho e roxo';
    if (v.includes('amarelo') || v.includes('gaia')) return 'Amarelo';
    return 'Outras cores';
  };
  const productCache = new Map();
  async function product(handle) {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
        .then(response => { if (!response.ok) throw new Error('Não foi possível carregar uma peça.'); return response.json(); })
        .catch(error => { productCache.delete(handle); throw error; }));
    }
    return productCache.get(handle);
  }
  async function manifest(url) {
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Não foi possível carregar os conjuntos.');
    return response.json();
  }
  function variantsFor(productData, color) {
    const names = (productData.options || []).map(option => clean(typeof option === 'string' ? option : option.name));
    let colorIndex = names.findIndex(name => name === 'cor' || name === 'color');
    if (colorIndex < 0) colorIndex = (productData.variants[0]?.options || []).findIndex(value => clean(value) === clean(color));
    const sizeIndex = names.findIndex(name => name === 'tamanho' || name === 'size');
    return productData.variants.filter(variant => variant.available && clean(variant.options[colorIndex]) === clean(color)).map(variant => ({
      id: variant.id,
      size: variant.options[sizeIndex >= 0 ? sizeIndex : (colorIndex === 0 ? 1 : 0)] || variant.public_title || variant.title,
      price: Number(variant.price),
      compareAtPrice: Number(variant.compare_at_price) || 0,
    }));
  }
  function priceHtml(variant) {
    if (!variant) return 'Indisponível';
    const current = money.format(variant.price / 100);
    return variant.compareAtPrice > variant.price
      ? `<span class="ff-price"><s aria-label="Preço original">${money.format(variant.compareAtPrice / 100)}</s><strong aria-label="Preço atual">${current}</strong></span>`
      : `<strong>${current}</strong>`;
  }
  function card(pair, color, index) {
    const count = pair.colors.length;
    return `<article class="ff-pair" data-pair="${html(pair.id)}" data-color-index="${index}">
      <div class="ff-pair__images">
        <img src="${html(color.topPhoto)}" alt="${html(pair.top.title)} em ${html(color.top)}" loading="lazy" width="300" height="390">
        <img src="${html(color.bottomPhoto)}" alt="${html(pair.bottom.title)} em ${html(color.bottom)}" loading="lazy" width="300" height="390">
      </div>
      <div class="ff-pair__body"><p class="ff-pair__names">${html(pair.top.title)} <span>+</span> ${html(pair.bottom.title)}</p>
        <p class="ff-pair__color">${html(color.top)}${clean(color.top) !== clean(color.bottom) ? ` · ${html(color.bottom)}` : ''}${count > 1 ? ` · mais ${count - 1} ${count === 2 ? 'cor' : 'cores'}` : ''}</p>
        <button type="button" class="ff-pair__choose" data-open-pair="${html(pair.id)}">Escolher peças</button>
      </div></article>`;
  }
  function setupBuilder(element, data) {
    const cards = element.querySelector('[data-ff-cards]');
    const colors = element.querySelector('[data-ff-colors]');
    const dialog = element.querySelector('[data-ff-dialog]');
    const sizeStatus = element.querySelector('[data-size-status]');
    const sizeFilters = { top: element.querySelector('[data-size-filter=top]'), bottom: element.querySelector('[data-size-filter=bottom]') };
    const bottomType = element.querySelector('[data-bottom-type]');
    const priceSort = element.querySelector('[data-price-sort]');
    const clearFilters = element.querySelector('[data-clear-filters]');
    const groups = [...new Set(data.pairs.flatMap(pair => pair.colors.map(color => family(color.top))))];
    const order = ['Azul', 'Verde', 'Rosa e lilás', 'Terrosos', 'Preto e cinza', 'Branco', 'Vermelho e roxo', 'Amarelo', 'Outras cores'];
    groups.sort((a, b) => order.indexOf(a) - order.indexOf(b));
    colors.innerHTML = `<button type="button" data-filter="" aria-pressed="true">Todas</button>` + groups.map(group => `<button type="button" data-filter="${html(group)}" aria-pressed="false">${html(group)}</button>`).join('');
    let filter = '';
    let renderVersion = 0;
    const render = async () => {
      const version = ++renderVersion;
      const selectedSizes = { top: sizeFilters.top.value, bottom: sizeFilters.bottom.value };
      const checkingProducts = Boolean(selectedSizes.top || selectedSizes.bottom || priceSort.value);
      const hasFilters = Boolean(filter || bottomType.value || checkingProducts);
      const candidatePairs = data.pairs.filter(pair =>
        (!filter || pair.colors.some(color => family(color.top) === filter)) &&
        (!bottomType.value || clean(pair.bottom.title).includes(bottomType.value)));
      const loadedProducts = new Map();
      if (checkingProducts) {
        cards.setAttribute('aria-busy', 'true');
        cards.innerHTML = '<p>Conferindo conjuntos disponíveis…</p>';
        sizeStatus.textContent = 'Conferindo preços e tamanhos atuais…';
        try {
          const handles = [...new Set(candidatePairs.flatMap(pair => [pair.top.handle, pair.bottom.handle]))];
          for (let start = 0; start < handles.length; start += 8) {
            const batch = handles.slice(start, start + 8);
            const products = await Promise.all(batch.map(product));
            batch.forEach((handle, index) => loadedProducts.set(handle, products[index]));
          }
        } catch {
          if (version === renderVersion) {
            cards.innerHTML = '<p>Não foi possível conferir os conjuntos agora. Tente selecionar novamente.</p>';
            sizeStatus.textContent = 'Falha ao consultar preços e disponibilidade.';
            cards.removeAttribute('aria-busy');
          }
          return;
        }
      }
      if (version !== renderVersion) return;
      const matches = candidatePairs.flatMap(pair => {
        const options = pair.colors.flatMap((color, index) => {
          if (filter && family(color.top) !== filter) return [];
          if (!checkingProducts) return [{ color, index, total: 0 }];
          const choices = ['top', 'bottom'].map(key => variantsFor(loadedProducts.get(pair[key].handle), color[key])
            .filter(variant => !selectedSizes[key] || clean(variant.size) === clean(selectedSizes[key])));
          if (choices.some(variants => !variants.length)) return [];
          const lowestTotal = Math.min(...choices[0].map(variant => variant.price)) + Math.min(...choices[1].map(variant => variant.price));
          return [{ color, index, total: lowestTotal }];
        });
        if (!options.length) return [];
        const chosen = priceSort.value === 'asc' ? options.reduce((best, item) => item.total < best.total ? item : best)
          : priceSort.value === 'desc' ? options.reduce((best, item) => item.total > best.total ? item : best) : options[0];
        return [{ markup: card(pair, chosen.color, chosen.index), total: chosen.total }];
      });
      if (priceSort.value) matches.sort((left, right) => priceSort.value === 'asc' ? left.total - right.total : right.total - left.total);
      cards.innerHTML = matches.map(item => item.markup).join('') || '<p>Nenhum conjunto encontrado com esses filtros.</p>';
      sizeStatus.textContent = hasFilters ? `${matches.length} ${matches.length === 1 ? 'conjunto encontrado' : 'conjuntos encontrados'}.` : '';
      clearFilters.hidden = !hasFilters;
      cards.removeAttribute('aria-busy');
      colors.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === filter)));
    };
    render();
    element.addEventListener('change', event => {
      if (event.target.matches('[data-size-filter], [data-bottom-type], [data-price-sort]')) render();
    });
    element.addEventListener('click', async event => {
      if (event.target.closest('[data-clear-filters]')) {
        sizeFilters.top.value = '';
        sizeFilters.bottom.value = '';
        bottomType.value = '';
        priceSort.value = '';
        filter = '';
        render();
        return;
      }
      const filterButton = event.target.closest('[data-filter]');
      if (filterButton) { filter = filterButton.dataset.filter; render(); return; }
      const openButton = event.target.closest('[data-open-pair]');
      if (openButton) {
        const pair = data.pairs.find(item => item.id === openButton.dataset.openPair);
        const index = Number(openButton.closest('[data-color-index]').dataset.colorIndex);
        await openPair(dialog, pair, index, { top: sizeFilters.top.value, bottom: sizeFilters.bottom.value });
      }
    });
  }
  async function openPair(dialog, pair, initialIndex, selectedSizes = {}) {
    const content = dialog.querySelector('[data-ff-detail]');
    const error = dialog.querySelector('[data-ff-error]');
    error.textContent = '';
    content.innerHTML = '<p>Carregando tamanhos e preços…</p>';
    dialog.showModal();
    let top;
    let bottom;
    try { [top, bottom] = await Promise.all([product(pair.top.handle), product(pair.bottom.handle)]); }
    catch (cause) { content.innerHTML = '<p>Não foi possível carregar as peças. Tente novamente.</p>'; return; }
    const extraProducts = new Map();
    const extraHandles = [...new Set(pair.colors.map(color => color.extra?.handle).filter(Boolean))];
    await Promise.all(extraHandles.map(async handle => {
      try { extraProducts.set(handle, await product(handle)); } catch { /* O conjunto de duas peças continua disponível. */ }
    }));
    content.innerHTML = `<div class="ff-detail__head"><h2>Escolha suas peças</h2><button type="button" class="ff-detail__close" data-close aria-label="Fechar">×</button></div>
      <label class="ff-detail__color">Cor do conjunto<select data-pair-color>${pair.colors.map((entry, index) => `<option value="${index}" ${index === initialIndex ? 'selected' : ''}>${html(entry.top)}${clean(entry.top) !== clean(entry.bottom) ? ` / ${html(entry.bottom)}` : ''}</option>`).join('')}</select></label>
      <div class="ff-detail__pieces"><div data-piece="top"></div><div data-piece="bottom"></div></div>
      <div class="ff-detail__extra" data-extra-wrap hidden></div>
      <p class="ff-detail__total">Total: <strong data-total></strong></p><button type="button" class="ff-detail__add" data-add>Adicionar as duas peças ao carrinho</button>`;
    const draw = () => {
      const color = pair.colors[Number(content.querySelector('[data-pair-color]').value)];
      for (const [key, info, data] of [['top', pair.top, top], ['bottom', pair.bottom, bottom]]) {
        const options = variantsFor(data, color[key]);
        const piece = content.querySelector(`[data-piece="${key}"]`);
        piece.innerHTML = `<img src="${html(color[key + 'Photo'])}" alt="${html(info.title)} em ${html(color[key])}" width="280" height="360">
          <h3>${html(info.title)}</h3><p>${html(color[key])}</p>
          <label>Tamanho<select data-size="${key}">${options.map((variant, index) => `<option value="${index}" ${clean(variant.size) === clean(selectedSizes[key]) ? 'selected' : ''}>${html(variant.size)}</option>`).join('')}</select></label>
          <p data-price="${key}"></p>`;
        piece._variants = options;
        if (!options.length) piece.querySelector('select').innerHTML = '<option>Indisponível</option>';
      }
      const extraWrap = content.querySelector('[data-extra-wrap]');
      const extra = color.extra;
      const extraOptions = extra && extraProducts.has(extra.handle) ? variantsFor(extraProducts.get(extra.handle), extra.color) : [];
      extraWrap.hidden = !extraOptions.length;
      extraWrap._variants = extraOptions;
      if (extraOptions.length) {
        extraWrap.innerHTML = `<h3>Complete com uma terceira peça</h3>
          <label class="ff-detail__extra-choice"><input type="checkbox" data-extra-check>
          <img src="${html(extra.photo)}" alt="${html(extra.title)} em ${html(extra.color)}" width="100" height="130">
          <span><strong>${html(extra.title)}</strong><small>${html(extra.color)}</small><em>Adicionar ao conjunto</em></span></label>
          <label class="ff-detail__extra-size">Tamanho da terceira peça<select data-extra-size>${extraOptions.map((variant, index) => `<option value="${index}" ${clean(variant.size) === clean(selectedSizes.top) ? 'selected' : ''}>${html(variant.size)}</option>`).join('')}</select></label>
          <p data-extra-price></p>`;
      } else extraWrap.innerHTML = '';
      update();
    };
    const update = () => {
      let total = 0;
      let available = true;
      for (const key of ['top', 'bottom']) {
        const piece = content.querySelector(`[data-piece="${key}"]`);
        const chosen = piece._variants[Number(piece.querySelector('select').value)];
        piece.querySelector('[data-price]').innerHTML = priceHtml(chosen);
        if (chosen) total += chosen.price; else available = false;
      }
      const extraWrap = content.querySelector('[data-extra-wrap]');
      if (!extraWrap.hidden) {
        const chosen = extraWrap._variants[Number(extraWrap.querySelector('[data-extra-size]').value)];
        extraWrap.querySelector('[data-extra-price]').innerHTML = priceHtml(chosen);
        if (extraWrap.querySelector('[data-extra-check]').checked) {
          if (chosen) total += chosen.price; else available = false;
        }
      }
      content.querySelector('[data-total]').textContent = available ? money.format(total / 100) : '—';
      content.querySelector('[data-add]').disabled = !available;
      content.querySelector('[data-add]').textContent = !extraWrap.hidden && extraWrap.querySelector('[data-extra-check]').checked ? 'Adicionar as três peças ao carrinho' : 'Adicionar as duas peças ao carrinho';
    };
    draw();
    content.onchange = event => {
      if (event.target.matches('[data-pair-color]')) draw();
      if (event.target.matches('[data-size], [data-extra-size], [data-extra-check]')) update();
    };
    content.onclick = async event => {
      if (event.target.closest('[data-close]')) { dialog.close(); return; }
      const button = event.target.closest('[data-add]');
      if (!button) return;
      const selected = ['top', 'bottom'].map(key => {
        const piece = content.querySelector(`[data-piece="${key}"]`);
        return piece._variants[Number(piece.querySelector('select').value)];
      });
      const extraWrap = content.querySelector('[data-extra-wrap]');
      if (!extraWrap.hidden && extraWrap.querySelector('[data-extra-check]').checked) {
        selected.push(extraWrap._variants[Number(extraWrap.querySelector('[data-extra-size]').value)]);
      }
      if (selected.some(value => !value)) return;
      button.disabled = true;
      error.textContent = '';
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: selected.map(value => ({ id: value.id, quantity: 1 })) }),
        });
        if (!response.ok) throw new Error('Não foi possível adicionar as peças. Confira a disponibilidade e o carrinho antes de tentar novamente.');
        window.location.assign(`${root}cart`);
      } catch (cause) { error.textContent = cause.message; button.disabled = false; }
    };
  }
  async function setupRelated(element, data) {
    const handle = element.dataset.productHandle;
    const matching = data.pairs.filter(pair => pair.top.handle === handle || pair.bottom.handle === handle || pair.colors.some(color => color.extra?.handle === handle));
    if (!matching.length) return;
    let current;
    try { current = await product(handle); } catch { return; }
    const holder = element.querySelector('[data-ff-related]');
    const render = async () => {
      const selectedId = new URLSearchParams(location.search).get('variant') || element.dataset.variantId;
      const selected = current.variants.find(variant => String(variant.id) === String(selectedId)) || current.variants.find(variant => variant.available);
      if (!selected) return;
      const relevant = matching.flatMap(pair => pair.colors.flatMap(color => {
        const side = pair.top.handle === handle ? 'top' : pair.bottom.handle === handle ? 'bottom' : color.extra?.handle === handle ? 'extra' : null;
        if (!side) return [];
        const selectedColor = side === 'extra' ? color.extra.color : color[side];
        if (!variantsFor(current, selectedColor).some(variant => variant.id === selected.id)) return [];
        const suggestions = ['top', 'bottom'].filter(key => key !== side).map(key => ({
          product: pair[key], color: color[key], photo: color[key + 'Photo'],
        }));
        if (color.extra && side !== 'extra') suggestions.push({
          product: { handle: color.extra.handle, title: color.extra.title }, color: color.extra.color, photo: color.extra.photo,
        });
        return suggestions;
      }));
      const unique = [...new Map(relevant.map(item => [`${item.product.handle}:${item.color}`, item])).values()];
      const visible = [];
      for (const item of unique.slice(0, 8)) {
        try { if (variantsFor(await product(item.product.handle), item.color).length) visible.push(item); } catch { /* Keep other matches. */ }
      }
      element.hidden = !visible.length;
      holder.innerHTML = visible.map(item => `<a class="ff-related__card" href="${root}products/${encodeURIComponent(item.product.handle)}">
        <img src="${html(item.photo)}" alt="${html(item.product.title)} em ${html(item.color)}" loading="lazy" width="220" height="286">
        <span>${html(item.product.title)}</span><small>${html(item.color)}</small></a>`).join('');
    };
    render();
    window.addEventListener('popstate', render);
    document.addEventListener('change', () => window.setTimeout(render, 200));
  }
  document.querySelectorAll('[data-ff-builder], [data-ff-product-related]').forEach(async element => {
    try {
      const data = await manifest(element.dataset.manifestUrl);
      if (element.hasAttribute('data-ff-builder')) setupBuilder(element, data);
      else setupRelated(element, data);
    } catch {
      if (element.hasAttribute('data-ff-builder')) element.querySelector('[data-ff-cards]').innerHTML = '<p>Não foi possível carregar os conjuntos. Recarregue a página.</p>';
    }
  });
})();

